var map = {
	"./admin-components-old/components/categories-nestable.vue": 3346,
	"./admin-components-old/components/category-tree.vue": 5178,
	"./admin-components-old/components/nested-draggable.vue": 5120,
	"./admin-components-old/components/tags-input.vue": 856,
	"./components/ExampleComponent.vue": 7881,
	"./components/autocomplete.vue": 3490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7373;